//@ts-check
import $ from "jquery";
import { supportedLanguages } from "./constants.js";
import {logger} from "./logger"

export function focusInField(field) {
    field.find("a span").children().first().focus();
}

export function getCurrentPage() {
    const currentPageHiddenFieldSelector = document.querySelector("input[name='current_page']");
    if (currentPageHiddenFieldSelector) {
        //@ts-ignore //FIXME
        return currentPageHiddenFieldSelector.value;
    }

    return getLastPartOfCurrentUrl();
}

function getLastPartOfCurrentUrl() {
    const parts = window.location.pathname.split('/');
    return parts.length > 1 ? parts[1] : '';
}

// TODO: merge "getCurrentReactPage" into "getCurrentPage"
// for this we need to make sure that we we check for length of getCurrentPage somewhere in the code,
// business logic that is executed when lenght of getCurrentPage is zero, is persisted
export function getCurrentReactPage() {
    return getLastPartOfCurrentUrl();
}

export function getFirstSegmentFromUrl() {
    const parts = window.location.pathname.split('/');
    return parts.length > 1 ? parts[1] : '';
}


export function scrollToTop(speed) {
    if (!speed) {
        speed = 0;
    }

    $("html, body").animate(
        {
            scrollTop: 0,
        },
        speed
    );
}

export function initPopup(command) {
    logger.trace("initPopup",command)
    if (command === "fixed") {
        $(".x_page").addClass("fixed");
    }

    $(".x_page").show(0);
    $(".popup_load_spinner").hide();

    if (command !== "fixed") {
        scrollToTop(0);
    }
}

export function closePopup() {
    $(".x_page").hide();
    $(".x_page .x_window .x_content").remove();
}

/* POPUP ERROR INFO SUCCESS MESSAGE */
export function popupInfo(showHide, type, message, dataCy = "info-popup") {
    let defaultMessage;

    $(".x_page .x_window .x_content .info_strip")
        .removeClass("error")
        .removeClass("success");

    if (showHide === "hide") {
        $(".x_page .x_window .x_content .info_strip").hide();
    } else {
        $(".x_page .x_window .x_content .info_strip").show();
        $(".x_page .x_window .x_content .info_strip").attr("data-cy", dataCy);

        if (type === "error") {
            defaultMessage = "Error: Please try again or contact support.";
            $(".x_page .x_window .x_content .info_strip").addClass("error");
        } else if (type === "success") {
            defaultMessage =
                "Success: The requested action has been performed.";
            $(".x_page .x_window .x_content .info_strip").addClass("success");
        } else if (type === "info") {
            defaultMessage =
                "Success: The requested action has been performed.";
            $(".x_page .x_window .x_content .info_strip").addClass("info");
        }

        if (message) {
            $(".x_page .x_window .x_content .info_strip .message").html(
                message
            );
        } else {
            $(".x_page .x_window .x_content .info_strip .message").html(
                defaultMessage
            );
        }
    }
}

export function validatePhoneNumber(input_str) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input_str);
}

export function validatePhoneForE164(phoneNumber) {
    const regEx = /^\+[1-9]\d{10,14}$/;

    return regEx.test(phoneNumber);
}

export function fetchWapper(apiEndpoint, options = {}) {
    const csrfTokenElement = document.querySelector("meta[name='Csrf-Token']");
    const csrfToken = csrfTokenElement
        ? csrfTokenElement.getAttribute("content")
        : "no token given";

    return fetch(apiEndpoint, {
        ...options,
        headers: {
            ...options.headers,
            "Csrf-Token": csrfToken,
        },
    });
}

function returnValidatedLanguage(input) {
    // create array of supported language codes from supportedLanguages array
    const supportedLanguagesCodes = [];

    $.each(supportedLanguages, function (i) {
        var languageCode = supportedLanguages[i].substring(
            0,
            supportedLanguages[i].indexOf("/")
        );

        supportedLanguagesCodes.push(languageCode);
    });

    // if chosen language not in array, use English
    if ($.inArray(input, supportedLanguagesCodes) === -1) {
        input = "en";
    }

    return input;
}

export function getLanguage() {
    return returnValidatedLanguage(
        $('[name="current_chosen_language"]').val()
            ? $('[name="current_chosen_language"]').val()
            : $('[name="default_language"]').val()
    );
}

export function setCSRFheaders() {
    const csrf_token = $('meta[name="Csrf-Token"]').attr("content");

    if (csrf_token) {
        function csrfSafeMethod(method) {
            // these HTTP methods do not require CSRF protection
            return (/^(GET|HEAD|OPTIONS)$/.test(method));
        }

        $.ajaxSetup({
            beforeSend: function (xhr, settings) {
                if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                    xhr.setRequestHeader("Csrf-Token", csrf_token);
                }
            }
        });
    }
}

/* SIGNING PAGE - CHECK IF FLEXIBLE SIGNING IS ACTIVE */
export function isFlexibleSigning() {
    if (
        getCurrentPage() === "sign_document" &&
        $("body").find('[name="flexible_signing_enabled"]').val() == 1
    ) {
        return true;
    }

    return false;
}


/* TRANSLATE LANGUAGE */
//TODO @GLOBAL translationArray
// !!! extract without translationArray defined inline !!
export function translateLanguage(string) {
		
	var result;
	//@ts-ignore //FIXME
	if ($('body').find('[name="dynamic_translation_enabled"]').val() == 1 && translationArray[string]) {		
	//@ts-ignore //FIXME
        result = translationArray[string];
	} else {
		
		if ($('body').find('[name="dynamic_translation_enabled"]').val() != 1) {
		//console.log('translation disabled');	
		}
		//@ts-ignore //FIXME
		if (!translationArray[string]) {
		//console.log('string translation not found');	
		}
				
	result = string;
	}
		
	// return result with backslashes (added by PHP) removed 
	return result.replace(/\\/g, '');;

}

export function isTouchDevice() {
    return 'ontouchstart' in window        // works on most browsers 
        || navigator.maxTouchPoints;       // works on IE10/11 and Surface
};

/* UCFIRST - CAPITALIZE FIRST LETTER OF STRING */
export function ucFirst(value) {
	'use strict';
	
	if (!value){
	return false;	
	}
	
	return value.replace(/^./, value[0].toUpperCase());
}

/* UCWORDS - CAPITALIZE FIRST LETTER OF EACH WORD IN STRING */
export function ucWords(value) {
	'use strict';
	
	if (!value){
	return false;	
	}
		
	var returnValue = value.toLowerCase().replace(/\b[a-z]/g, function(letter) {
    return letter.toUpperCase();
	});
	
	return returnValue;
}


/* GENERAL PANEL ERROR INFO SUCCESS MESSAGE */
export function generalInfo(showHide, type, message) {
    if (showHide === "hide") {
        $(".alert.dynamic").remove();
    } else if (showHide && type && message) {
        scrollToTop(0);
        $("aside#alerts").html(
            '<p class="alert ' + type + ' dynamic">' + message + "</p>"
        );
    }
}

export function dateWithMonthsOffset(months) {
    if (months) {
        const date = new Date();
        date.setMonth(date.getMonth() + months);
        return date;
    }
}

export function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function addNewFeatureIndicator() {
    const cookieName = "eversign_feature_highlight";
    const userAlreadyClicked = getCookie(cookieName);
    const buttons = $(`*[data-new-feature-indicator="true"]`);
    const pulseMarkup = `
        <div class="evr-pulse">
            <div class="evr-pulse-dot"></div>
        </div>
    `;

    function removePulseAnimationsFromButtons() {
        buttons.each(function(){
            $(this).children('.evr-pulse').remove();
        });
    }

    if (buttons.length > 0 && !userAlreadyClicked) {
        buttons.each(function(){
            const buttonHasNoPulseYet = $(this).children('.evr-pulse').length <= 0;
            buttonHasNoPulseYet && $(this).append(pulseMarkup);
        });

        buttons.click(function(){
            document.cookie = cookieName + '=1; expires=' + dateWithMonthsOffset(12) + '; SameSite=Lax';
            removePulseAnimationsFromButtons();
        });
    }
}


/* DYNAMICALLY CALL TIPR PLUGIN */
export function fireTiprPlugin() {
    $("body")
        .find(".tipr")
        .each(function () {
            //@ts-ignore //FIXME
            $(this).tipr();
        });
    $("body")
        .find(".tiprtop")
        .each(function () {
            //@ts-ignore //FIXME
            $(this).tipr({
                mode: "top",
            });
        });
}
    

/* MARK CURRENT PAGE SIDEBAR */
export function markSidebarSelected(currentPageIdentifier) {
	let pageIdentifier;
	
	switch (currentPageIdentifier) {
		case 'recinvoices':
		pageIdentifier = 'invoices';
		break;
	
		case 'recbills':
		pageIdentifier = 'bills';
		break;
		
		default:
		pageIdentifier = currentPageIdentifier;
		break;
	}
	
	$('.sidebar_menu ul').find('li[data-page-identifier]').removeClass();
	$('.sidebar_menu ul').find('li[data-page-identifier="'+pageIdentifier+'"]').addClass('current');
}

/* DISABLE WINDOW UNLOAD ALERT CONFIRMATION */
export function unbindBeforeUnload() {
	$(window).off('beforeunload');
}

/* WINDOW UNLOAD ALERT CONFIRMATION */
export function bindBeforeUnload() {
	// for real page change actions, including tab-close or window-close 
	$(window).on('beforeunload', function(){		
  		return 'Are you sure you want to leave this page? Changes you made may not be saved.'
	});
}

export function escapeHtml (string) {
    // ADD escape function
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };

	return String(string).replace(/[&<>"'`=\/]/g, function (s) {
        return entityMap[s];
    });
}

/* HELPER FUNCTION TO CLEAN GET VARIABLES IN UPDATE TABLE FUNCTION, 
used in search / autocomplete in lists */
export function cleanTableGetVariable(input) {
	// input will be like "contact:d45ba3d8cd1b48e98a95c6b7403b5c18"
	if (typeof input === 'undefined') {
		return false;
	}
				
	if (input) { 
		input = String(input)
            .replace('contact:', '')
            .replace('search:', '')
            .replace('page:', '');

		return escapeHtml(input); 
	}
}


/* VALIDATE EMAIL */
export function isValidEmailAddress(emailAddress) {
    var pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
    return pattern.test(emailAddress);
}


/* VALIDATE URL */
export function is_valid_url(url) {
    return /^(http(s)?:\/\/)?(www\.)?[a-z0-9]+(([\.]{1}|[\-]+)[a-z0-9]+)*\.[a-z]{2,}(:[0-9]{1,5})?([\/?]\S*)?$/.test(url);
}

export function is_valid_localhost_url(url) {
    return /^http:\/\/\w+(\.\w+)*(:[0-9]+)?\/?(\/[.\w]*)*$/.test(url);
}

export function url_has_protocol(url) {
    return /^(http(s)?:\/\/).+$/.test(url);
}

/* CHECK IF STRING CONTAINS EMAIL */
export function checkIfEmailInString(text) { 
    var re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
    return re.test(text);
}


/* EXTRACT ALL EMAILS FROM STRING */
export function extractEmails(text)
{
    return text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
}

/* GENERATE RANDOM HASH */
function rand() {
    return Math.random().toString(36).substr(2); // remove `0.`
};

export function token() {
    return rand() + rand(); // to make it longer
};


/* CHECK IF IN IFRAME */
export function inIframe () {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}

export function getParamFromUrl(paramName) {
	const urlParams = new URLSearchParams(window.location.search);
	const retrivedParam = urlParams.get(paramName);
	return retrivedParam;
}

/* CONVERT RGB(A) TO HEX */
export function rgb2hex(rgb){
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return (rgb && rgb.length === 4) ? "#" +
     ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
     ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
     ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
   }
   
export function getTodaysDate() {
	"use strict";
	
	var d = new Date();

	var month = d.getMonth()+1;
	var day = d.getDate();

	var output = d.getFullYear() + '-' +
    	((''+month).length<2 ? '0' : '') + month + '-' +
    	((''+day).length<2 ? '0' : '') + day;
	
	return output;

}

function isRecapchaActionNameValid(input) {
    const regex = /^[A-Za-z/_]+$/;  // Regular expression pattern
  
    // Test if the string matches the regex, return false if not
    return regex.test(input);
  }

// every X second generate recaptcha token on pages where we included recaptcha
export function generateRecaptchaToken (source = "default") {
    if (typeof(grecaptcha) !== 'undefined') {

        if (!isRecapchaActionNameValid(source)) {
            console.log('this is not valid recaptcha action name for source, resetting to default', source);
            source = "default"
        }

        grecaptcha.ready(function () {
            grecaptcha.execute(window.__RECAPTCHA_V3_SITEKEY__, {action: source}).then(function (token) {
                $('body').find('[name="recaptcha_token"]').val(token);
                window.dispatchEvent(new Event('RECAPTCHA_TOKEN_GENERATED'));
			});
		});
        
        const regeneratedActionPrefix = 'regenerated_from_';
        if (!source.includes(regeneratedActionPrefix)) {
            source = `${regeneratedActionPrefix}${source}`;
        }
	
		// We generate a new recaptcha token every minute to bypass the timeout of tokens.
        window.setTimeout(function() {
            console.log('recaptcha regen source: ', source);
            generateRecaptchaToken(source)
        }, 110000);
	}
}

export function isEmail(email) {
    var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regex.test(email);
}
  
export function renderSpinner() {
    return `<div class="lds-ring"><div></div><div></div><div></div><div></div></div>`
}

export function addBackgroundToCookieBanner() {
    if (!window.Osano || typeof window.Osano === "undefined") {
        return
    }
    const osanoBackground = document.createElement('div');
    
    // https://docs.osano.com/developer-documentation-consent-javascript-api#osano-cm-initialized
    //@ts-ignore
    window.Osano.cm.addEventListener('osano-cm-initialized', (consent) => {
        const cookieBannerNotAccepted = consent === undefined
        if (cookieBannerNotAccepted) {
            osanoBackground.innerHTML = "";
            osanoBackground.className = "osano-background"
            document.body.appendChild(osanoBackground);
        }
    })
    
    //@ts-ignore
    window.Osano.cm.addEventListener('osano-cm-consent-saved', (consent) => {
        const bg = document.getElementsByClassName('osano-background')[0];
    
        if (bg !== undefined) {
            document.body.removeChild(bg)
        }
    })
}

export function setBingConsentGrantedOnOsanoBannerAccepted() {
    //@ts-ignore
    if (!window.Osano || typeof window.Osano === "undefined") {
        return
    }

    //@ts-ignore
    window.Osano.cm.addEventListener('osano-cm-initialized', (consent) => {
        // Set bing tracking ad storage to be granted, when cookie xodosign_bing_consent_granted is set
        if (consent && consent.STORAGE && consent.STORAGE === 'ACCEPT') {
            document.cookie = 'xodosign_bing_consent_granted=1; expires=' + dateWithMonthsOffset(12) + '; SameSite=Lax';
        }
    })

    //@ts-ignore
    window.Osano.cm.addEventListener('osano-cm-consent-saved', (consent) => {
        // Set bing tracking ad storage to be granted, when cookie xodosign_bing_consent_granted is set
        if (consent && consent.STORAGE && consent.STORAGE === 'ACCEPT') {
            document.cookie = 'xodosign_bing_consent_granted=1; expires=' + dateWithMonthsOffset(12) + '; SameSite=Lax';
        }
    })
}
